import React from "react";

import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "../svgs/Logo";
import { ReactComponent as Hamburger } from "../pictures/hamburger.svg";
import { HamburgerStore, LoginModalStore } from "./Store";
import { useAuthenticator } from "@aws-amplify/ui-react";
import LogoutIcon from "@mui/icons-material/Logout";

const DESKTOP_BREAKPOINT = 900;

export const TopBar = ({ topBarLinks, isKedma = false }) => {
  const { setHamburger } = HamburgerStore();
  const { openLoginModal } = LoginModalStore();
  const { route, user, signOut } = useAuthenticator((context) => [
    context.route,
    context.user,
  ]);
  const navigate = useNavigate();
  const isAuthenticated = route === "authenticated" && Boolean(user);

  return (
    <Container>
      <LogoContainer>
        <Logo width={32} height={37}></Logo>
      </LogoContainer>

      {isKedma ? (
        <TopBarTitle to="/kedma-welcome">ארכיון קדמה</TopBarTitle>
      ) : (
        <TopBarTitle to="/welcome">ארכיון בארי</TopBarTitle>
      )}
      <HamburgerContainer>
        <Hamburger
          onClick={() => {
            setHamburger(true);
          }}
        ></Hamburger>
      </HamburgerContainer>
      {topBarLinks.map((item, id) => {
        const isLoginLink = item.action === "login";
        const linkItem =
          isLoginLink && isAuthenticated
            ? {
                ...item,
                href: "",
                title: user.username,
                icon: <StyledLogoutIcon />,
                onClick: async (event) => {
                  event.preventDefault();
                  try {
                    await signOut();
                  } finally {
                    navigate("/welcome", { replace: true });
                  }
                },
              }
            : isLoginLink
              ? {
                  ...item,
                  onClick: (event) => {
                    event.preventDefault();
                    openLoginModal();
                  },
                }
            : item;
        return (
          <TopBarOption
            title={linkItem.title}
            key={id}
            icon={linkItem.icon ? linkItem.icon : null}
            href={linkItem.href}
            onClick={linkItem.onClick}
          />
        );
      })}
    </Container>
  );
};

export const TopBarOption = ({ title, icon, href, onClick }) => {
  const isInternal = href?.startsWith("/");
  return (
    <OptionContainer
      href={href}
      target={isInternal || !href ? "_self" : "_blank"}
      onClick={onClick}
    >
      {icon}
      {title}
    </OptionContainer>
  );
};

const Container = styled.div`
  height: 56px;
  width: 100vw;
  display: flex;
  color: white;
  justify-content: flex-start;

  @media (min-width: ${DESKTOP_BREAKPOINT}px) {
    align-items: center;
    justify-content: space-evenly;

    border-bottom: solid 1px #d8d8d8;
  }
`;

const StyledLogoutIcon = styled(LogoutIcon)`
  width: 16px;
  height: 16px;
  margin: 0px 0px 0px 8px;
`;

const HamburgerContainer = styled.div`
  width: 32px;
  height: 32px;
  margin: 12px;
  cursor: pointer;
  @media (min-width: ${DESKTOP_BREAKPOINT}px) {
    display: none;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
`;

const OptionContainer = styled.a`
  display: none;
  white-space: nowrap;
  @media (min-width: ${DESKTOP_BREAKPOINT}px) {
    display: block;
    padding-left: 16px;
    height: 24px;
    width: auto;
    font-family: Rubik;
    font-size: 13px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    text-align: right;
    color: rgba(0, 0, 0, 0.87);
    display: flex;
    align-items: center;
    text-decoration: none !important;
  }
`;

const TopBarTitle = styled(Link)`
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-right: 16px;
  width: auto;
  font-family: Rubik;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #000;
  white-space: nowrap;
  text-decoration: none !important;

  @media (min-width: ${DESKTOP_BREAKPOINT}px) {
    padding-right: 24px;
    font-size: 24px;
  }
`;
